"use strict";

/**
 * Clase HttpError para manejar y mostrar mensajes de error HTTP.
 */
export class HttpError {
    /**
     *
     * @param {Object} notification - Objeto para manejar notificaciones.
     */
    constructor(notification) {
        this.notification = notification;
    }

    /**
     * Obtiene un mensaje de error basado en el código de estado HTTP.
     * @param {number} status - Código de estado HTTP.
     * @returns {string} Mensaje de error correspondiente al código de estado.
     */
    getErrorMessage(status) {
        const errorMessages = {
            400: "La solicitud no se realizó correctamente. Por favor, verifique los datos e intente nuevamente.",
            401: "No autorizado. Verifique sus credenciales y vuelva a intentarlo.",
            403: "Acceso denegado. No tiene permisos para realizar esta acción.",
            404: "No encontrado. El recurso solicitado no existe.",
            405: "Método no permitido. El método utilizado no está permitido para esta acción.",
            500: "Error interno del servidor. Algo salió mal en el servidor.",
            502: "Puerta de enlace incorrecta. El servidor está recibiendo una respuesta inválida de otro servidor.",
            503: "Servicio no disponible. El servidor está temporalmente fuera de servicio.",
            504: "Tiempo de espera agotado. El servidor tardó demasiado en responder.",
            default:
                "Ocurrió un error inesperado. Por favor, intente nuevamente más tarde.",
        };

        return errorMessages[status] || errorMessages.default;
    }

    /**
     * Maneja un error HTTP y muestra un mensaje de error correspondiente.
     * @param {Object} error - Objeto de error HTTP, que debe contener una propiedad 'response' con un código de estado.
     */
    handleHttpError(error) {
        const message = this.getErrorMessage(error.response.status);
        this.notification.showToasted("alive", "error", message);
    }
}
